import { useSyncExternalStore } from 'react'

let disconnected = false
const listeners = new Set<() => void>()

export function setActivityDisconnected(value: boolean): void {
  if (disconnected === value) return
  disconnected = value
  listeners.forEach((fn) => fn())
}

export function useActivityDisconnected(): boolean {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn)
      return () => {
        listeners.delete(fn)
      }
    },
    () => disconnected,
    () => false,
  )
}
